<div *ngIf="!isLoading">
    <app-reports-form [formModel]="model"></app-reports-form>
</div>
